const state = {
  requests_failed_list: []
}

export default state



//////////////////
// WEBPACK FOOTER
// ./state/request/request.state.js
// module id = null
// module chunks = 